import styles from './MarketInsightsSidebarNotification.module.scss';
import { IconArrowUpRight, IconBulb, IconX } from '@tabler/icons-react';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';
import { IconCircleFilled } from '@tabler/icons-react';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import classNames from 'classnames';
import { useAtom } from 'jotai';
import { marketInsightVersionStatusAtom } from 'store/marketInsightVersionStatusAtom';
import { useNavigateKeepParams } from 'components/KeepParamsRouter/KeepParamsRouter';
import Chip from '@lotlinx-aws/sparky-component-library/Sparky/Chip';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { FeatureFlag } from 'types/FeatureFlags';

/**
 * MarketInsightsSidebarNotification
 */
export default function MarketInsightsSidebarNotification() {
  const [marketInsightVersionStatus, setMarketInsightVersionStatus] = useAtom(
    marketInsightVersionStatusAtom,
  );
  const isMarketInsightsV2Enabled = useFeatureFlag(FeatureFlag.ENABLE_MARKET_INSIGHTS_V2);

  const navigate = useNavigateKeepParams();

  if (!isMarketInsightsV2Enabled) {
    return null;
  }

  if (marketInsightVersionStatus === 'dismissed') {
    return (
      <Flex margin='0 16px '>
        <Chip
          variant='filled'
          color='blue'
          rightIcon={<IconArrowUpRight color='var(--chip-blue)' size={14} />}
          leftIcon={<IconBulb color='var(--chip-blue)' size={16} />}
          handleClick={() => navigate('/analytics/market_insights_v2')}
          className={styles.notificationChip}
        >
          Try Market Insights v2.0
        </Chip>
      </Flex>
    );
  }

  return (
    <div
      className={styles.marketinsightssidebarnotification}
      onMouseEnter={() =>
        marketInsightVersionStatus === 'unseen' && setMarketInsightVersionStatus('seen')
      }
    >
      <Flex width='100%' justifyContent='space-between'>
        <IconBulb size={32} color='var(--chip-blue)' />
        <IconButton
          aria-label='close notification'
          onClick={() => setMarketInsightVersionStatus('dismissed')}
        >
          <IconX size={16} color='var(--icon-subtle)' />
        </IconButton>
      </Flex>
      <Flex margin='12px 0 16px'>
        <Text type='label-01'>A new version of Market Insights is available</Text>
      </Flex>
      <Text type='body-01' color='secondary'>
        What's new:
      </Text>
      <Text type='body-01'>
        <Flex alignItems='flex-start' gap='8px' margin='8px 0 0 4px'>
          <IconCircleFilled size={6} className={classNames(styles.icon, styles.firstIcon)} />{' '}
          Identify underexposed and delivered VINs
        </Flex>
        <Flex alignItems='center' gap='8px' margin='0 0 0 4px'>
          <IconCircleFilled size={6} className={styles.icon} /> Market gap analysis
        </Flex>
        <Flex alignItems='center' gap='8px' margin='0 0 0 4px'>
          <IconCircleFilled size={6} className={styles.icon} /> Integrated map view
        </Flex>
      </Text>
      <Flex
        gap='8px'
        width='100%'
        justifyContent='flex-end'
        margin='12px 0 0 0'
        alignItems='center'
      >
        <Button size='sm' onClick={() => setMarketInsightVersionStatus('dismissed')}>
          Dismiss
        </Button>
        <Button size='sm' variant='solid' onClick={() => navigate('/analytics/market_insights_v2')}>
          Try it now
        </Button>
      </Flex>
    </div>
  );
}
